(async () => {
  // Aguarda o DOM estar pronto
  const variantPicker = document.querySelector('variant-picker[handle]');
  if (!variantPicker) return;

  const handle = variantPicker.getAttribute('handle');
  const formId = variantPicker.getAttribute('form-id');
  const swatchList = variantPicker.querySelector('.variant-swatch-list');
  if (!swatchList) return;

  // Busca todos os dados do produto via API (sem limite de 8)
  let product;
  try {
    const response = await fetch(`/products/${handle}.js`);
    product = await response.json();
  } catch (e) {
    console.error('Erro ao buscar produto:', e);
    return;
  }

  // Pega a opção de cor (primeira opção, position 1)
  const colorOption = product.options_with_values?.[0];
  if (!colorOption) return;

  const allValues = colorOption.values; // Todos os valores sem limite

  // Pega os valores já renderizados no DOM
  const renderedInputs = swatchList.querySelectorAll('input.variant-swatch__radio');
  const renderedValues = new Set(
    Array.from(renderedInputs).map(input => input.getAttribute('aria-label'))
  );

  // Se já estão todos renderizados, não faz nada
  if (renderedValues.size >= allValues.length) return;

  // Pega o ID do primeiro input para construir o padrão de ID
  const firstInput = renderedInputs[0];
  if (!firstInput) return;

  // Extrai o prefixo do ID: "option-template--XXXX__main--PRODUCTID-1-"
  const firstId = firstInput.id; // ex: option-template--18673421484205__main--8202782310573-1-1
  const idPrefix = firstId.replace(/-\d+$/, '-'); // remove o número final

  // Pega o nome do input (ex: option1)
  const inputName = firstInput.name;

  // Pega a forma do label existente para replicar o padrão de imagem
  // Encontra a variante para cada cor faltante
  allValues.forEach((colorName, index) => {
    if (renderedValues.has(colorName)) return; // já existe, pula

    // Encontra a variante correspondente a esta cor
    const variant = product.variants.find(v => v.option1 === colorName);
    if (!variant) return;

    // Pega a imagem da variante
    const imageUrl = variant.featured_image?.src;
    if (!imageUrl) return;

    // Formata a URL da imagem para diferentes tamanhos
    const getImageUrl = (src, size) => {
      return src.replace(/(\.[^.]+)(\?.*)?$/, `_${size}x$1$2`).replace('https:', '');
    };

    const inputId = `${idPrefix}${index + 1}`;
    const isAvailable = variant.available;

    const swatchDiv = document.createElement('div');
    swatchDiv.className = `variant-swatch${isAvailable ? '' : ' is-disabled'}`;

    swatchDiv.innerHTML = `
      <input
        class="variant-swatch__radio visually-hidden"
        type="radio"
        name="${inputName}"
        form="${formId}"
        id="${inputId}"
        value="${colorName}"
        data-option-position="1"
        aria-label="${colorName}"
      >
      <label class="variant-swatch__item" for="${inputId}">
        <span class="visually-hidden">${colorName}</span>
        <img
          class="variant-swatch__image"
          loading="lazy"
          sizes="(max-width: 740px) 64px, 72px"
          height="800"
          width="800"
          alt="${colorName}"
          src="//${getImageUrl(imageUrl, 216)}"
          srcset="
            //${getImageUrl(imageUrl, 64)} 64w,
            //${getImageUrl(imageUrl, 72)} 72w,
            //${getImageUrl(imageUrl, 128)} 128w,
            //${getImageUrl(imageUrl, 144)} 144w,
            //${getImageUrl(imageUrl, 192)} 192w,
            //${getImageUrl(imageUrl, 216)} 216w
          "
        >
      </label>
    `;

    swatchList.appendChild(swatchDiv);
  });

  // Vincula o evento de mudança nos novos swatches (o VariantPicker já escuta via delegate no form)
  // Os novos inputs têm data-option-position="1" e form=formId, então serão capturados automaticamente
})();